<template>
    <lateral-content v-model="showModal" compact header footer :title="$t('notificacoes')">
        <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false" />
        <div class="notificacao-container bg" v-if="!isEmpty">
            <div class="notificacao-list">
                <div
                    class="notificacao-item"
                    v-for="notificacao in notificacaoList"
                    :key="notificacao.id"
                >
                    <div class="notificacao-item-content">
                        <div class="notificacao-item-text" v-html="notificacao.notificacao"></div>
                        <div class="notificacao-item-info">
                            {{ $moment(notificacao.datahorainc).format('L LT') }}
                            <template v-if="notificacao.tabela != undefined">
                                • {{ $t(notificacao.tabela) }}
                            </template>
                            <template v-if="notificacao.route_name != undefined">
                                •
                                <router-link
                                    :to="createLink(notificacao)"
                                    @click.native="
                                        updateSituacao(notificacao);
                                        showModal = false;
                                    "
                                >
                                    Link
                                </router-link>
                            </template>
                        </div>
                    </div>
                    <div class="notificacao-item-action" @click="promptForDelete(notificacao)">
                        <b-icon icon="delete-outline" />
                    </div>
                </div>
            </div>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
                :selectable="false"
                simple
            />
        </div>
        <div class="notificacao-empty" v-else>
            <empty-table-message />
        </div>

        <template v-slot:footer-left>
            <b-button
                type="is-danger"
                icon-left="delete-outline"
                @click="promptForDelete()"
                :disabled="isLoading || isEmpty"
            >
                {{ $t('limpar') }}
            </b-button>
        </template>
        <template v-slot:footer-right>
            <b-button
                type="is-success"
                icon-left="cached"
                @click="carregarDadosDebounce()"
                :disabled="isLoading"
            >
                {{ $t('recarregar') }}
            </b-button>
        </template>
    </lateral-content>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Notification',

    props: {
        // ativo/inativo
        value: {
            type: Boolean,
            default: false,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            isLoading: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 15, 20, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isEmpty: true,
            notificacaoList: [],
            column: 'DATAHORAINC',
            order: 'desc',
            queryFilter: '',
            debounceNotification: null,
        };
    },
    computed: {
        ...mapState(['authenticated']),
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    watch: {
        value(val) {
            this.showModal = val;
        },
        showModal(val) {
            this.$emit('input', val);
        },
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    methods: {
        createLink(notificacao) {
            let temp = {
                name: notificacao.route_name,
            };
            if (notificacao.idregistro > 0) {
                temp.params = { id: notificacao.idregistro };
            } else if (notificacao.uuidregistro != undefined) {
                temp.params = { id: notificacao.uuidregistro };
            }

            return temp;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDadosDebounce() {
            clearTimeout(this.debounceNotification);
            this.debounceNotification = setTimeout(() => {
                this.carregarDados(this.pagination.currentPage);
            }, 1000);
        },
        carregarDados(currentPage = 1) {
            if (!this.authenticated) return;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.$axios
                .get(`geral/notificacao.json`, {
                    params: {
                        page: currentPage - 1,
                        limit: this.pagination.perPage,
                        column: this.column,
                        order: this.order,
                        param: this.queryFilter,
                    },
                })
                .then((response) => {
                    this.pagination.totalRows = response.data.totalElements;
                    this.notificacaoList = response.data.content;
                    this.isEmpty = this.notificacaoList.length <= 0;
                    // caso esteja numa página diferente da inicial e tenha limpado o único registro,
                    // carrega a página anterior
                    this.$emit('totalRows', this.pagination.totalRows);
                    if (this.isEmpty && currentPage > 1) {
                        this.pagination.currentPage--;
                        this.carregarDados(this.pagination.currentPage);
                    }
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        promptForDelete(notificacao = null) {
            this.$root.confirm({
                message: this.$t(
                    notificacao == null
                        ? 'remover-todas-as-notificacoes'
                        : 'remover-essa-notificacao'
                ),
                onConfirm: (_) => this.updateSituacao(notificacao),
            });
        },
        updateSituacao(notificacao = null) {
            if (this.isLoading) return;

            if (notificacao == null) {
                notificacao = {
                    id: 0,
                    situacao: 0,
                };
            }

            this.isLoading = true;
            notificacao.situacao = 0;
            this.$axios
                .post('geral/notificacao/updatesituacao', notificacao)
                .then((_) => {
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss">
.notificacao-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 250px;
    padding: 15px 15px 0 15px;
    .notificacao-list {
        flex-grow: 1;
        color: #fff;
        .notificacao-item {
            margin-bottom: 10px;
            background-color: $primary-color;
            border-radius: 5px;
            display: flex;
            min-height: 50px;
            .notificacao-item-content {
                padding: 10px;
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                .notificacao-item-text {
                    flex-grow: 1;
                    a {
                        color: #fff !important;
                        text-decoration: underline !important;
                    }
                }
                .notificacao-item-info {
                    padding-top: 5px;
                    font-size: 10px;
                    color: rgba(255, 255, 255, 0.8);
                    a {
                        color: #fff !important;
                        text-decoration: underline !important;
                    }
                }
            }
            .notificacao-item-action {
                cursor: pointer;
                padding-right: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
.notificacao-empty {
    padding: 15px;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
